var map = {
	"./Avatar.vue": "df3a",
	"./Block.vue": "2efe",
	"./Button.vue": "2a7d",
	"./Button/Unlock.vue": "ca8a",
	"./ButtonSelectLanguage.vue": "5542",
	"./Chart.vue": "0292",
	"./Container.vue": "185a",
	"./Countdown.vue": "50a0",
	"./CurrencyInput.vue": "0af9",
	"./Farms/Banner.vue": "d321",
	"./Farms/BuniFarmTr.vue": "7a8b",
	"./Farms/FarmTable.vue": "af9b",
	"./Farms/FarmTr.vue": "ec32",
	"./Farms/FilterActions.vue": "e87f",
	"./Farms/HeroArena/BuniFarmTr.vue": "61c1",
	"./Farms/HeroArena/FarmTable.vue": "33c8",
	"./Farms/HeroArena/FarmTr.vue": "08b3",
	"./Farms/HeroArena/FilterActions.vue": "d584",
	"./Farms/HeroArena/ModalStakeToken.vue": "b514",
	"./Farms/HeroArena/SelectFarms.vue": "7a13",
	"./Farms/HeroArena/StakedColumn.vue": "88c6",
	"./Farms/KryptoMonsterBanner.vue": "31f8",
	"./Farms/SelectFarms.vue": "8fe1",
	"./Farms/StakedColumn.vue": "95ca",
	"./Farms/TokenFarm/FarmTable.vue": "fe7b",
	"./Farms/TokenFarm/FarmTr.vue": "7baa",
	"./Farms/TokenFarm/ModalStakeToken.vue": "caaa",
	"./Farms/TokenFarm/StakedColumn.vue": "cc7e",
	"./Farms/TokenFarm/TokenFarmBanner.vue": "626f",
	"./Filters.vue": "35ce",
	"./FooterSideBar.vue": "9480",
	"./Form/Crp.vue": "be6f",
	"./Icon.vue": "cdae",
	"./ItemLink.vue": "05b7",
	"./Kurve/KurveSwapInput.vue": "edb5",
	"./Kurve/LiquidityInput.vue": "6333",
	"./Kurve/LiquidityItem.vue": "31d8",
	"./Kurve/LiquidityPoolInput.vue": "b4a6",
	"./Kurve/MyKurveLiquidity.vue": "b6ec",
	"./Kurve/PoolSwap.vue": "c965",
	"./List/Loading.vue": "26f0",
	"./List/Pool.vue": "be3b",
	"./List/Pools.vue": "8160",
	"./List/Token.vue": "be55",
	"./List/Tokens.vue": "29ed",
	"./Message/Error.vue": "66a4",
	"./Message/SimilarPools.vue": "a0f9",
	"./Message/Slippage.vue": "9efc7",
	"./Message/Warning.vue": "6d80",
	"./Message/WarningPreStaking.vue": "ab2f",
	"./Message/WarningRateChange.vue": "5b50",
	"./Message/WarningSetupProxy.vue": "9e8b",
	"./Message/WarningToken.vue": "47e9",
	"./Modal/About.vue": "8188",
	"./Modal/Account.vue": "34ec",
	"./Modal/Activity.vue": "68b3",
	"./Modal/AddLiquidity.vue": "3960",
	"./Modal/AddLiquidityKurve.vue": "34a2",
	"./Modal/CustomToken.vue": "23a7",
	"./Modal/EditCap.vue": "66b4",
	"./Modal/EditController.vue": "7740",
	"./Modal/EditPublicSwap.vue": "1a55",
	"./Modal/EditSwapFee.vue": "91bc",
	"./Modal/EditTokens.vue": "2164",
	"./Modal/EditWeights.vue": "d910",
	"./Modal/EditWeightsGradually.vue": "c5cc",
	"./Modal/ManageWhitelist.vue": "2ba2",
	"./Modal/PoolCreation.vue": "16c6",
	"./Modal/RemoveLiquidity.vue": "03fe",
	"./Modal/RemoveLiquidityKurve.vue": "27df",
	"./Modal/SelectToken.vue": "c8e2",
	"./Modal/TestnetWarning.vue": "c56f",
	"./Modal/TradingCompetitionCampaign.vue": "76f1",
	"./Modal/Wrapper.vue": "ba88",
	"./MyPoolShares.vue": "0fec",
	"./Nav.vue": "216c",
	"./Notifications.vue": "e985",
	"./Page.vue": "9973",
	"./ParentLink.vue": "e15a",
	"./Pie.vue": "4336",
	"./PoolBoxes.vue": "ad9b",
	"./PoolHeader.vue": "a7ff",
	"./PoolOverview.vue": "63da",
	"./PreStaking/ModalStakeToken.vue": "166d",
	"./PreStaking/PreStakingFilterActions.vue": "591c",
	"./PreStaking/PreStakingSelectFarms.vue": "2aaf",
	"./PreStaking/PreStakingTable.vue": "e9b1",
	"./PreStaking/PreStakingTr.vue": "ac10",
	"./PreStaking/StakedColumn.vue": "a35a",
	"./Progress.vue": "ad18",
	"./Search.vue": "c106",
	"./Sidebar.vue": "5ea5",
	"./SingleMultiToggle.vue": "23b0",
	"./Sticky.vue": "c6f5",
	"./SwitchTheme.vue": "e7e7",
	"./Tabs.vue": "b50c",
	"./Title.vue": "43b3",
	"./Toggle.vue": "ae48",
	"./Token.vue": "837d",
	"./Topnav.vue": "2fc9",
	"./Ui/Button.vue": "64c4",
	"./Ui/Checkbox.vue": "fd36",
	"./Ui/Counter.vue": "2fbf",
	"./Ui/Label.vue": "8af8",
	"./Ui/Loading.vue": "d1e9",
	"./Ui/LoadingPage.vue": "7238",
	"./Ui/Modal.vue": "ae01",
	"./Ui/Modal/Form.vue": "8540",
	"./Ui/Modal/ModalROI.vue": "4c7b",
	"./Ui/Modal/ModalStakeGameNFT.vue": "ed74",
	"./Ui/Modal/ModalStakeNFT.vue": "3d7a",
	"./Ui/Modal/ModalStakeToken.vue": "c631",
	"./Ui/Modal/ModalWarningClaimNFT.vue": "b2d7",
	"./Ui/Modal/ModalWarningHarvestNFTFarm.vue": "dc2f",
	"./Ui/Modal/ModalWarningNFTFarm.vue": "1ad7",
	"./Ui/Modal/ModalWarningStake.vue": "9e91",
	"./Ui/Modal/ModalWarningUnstakeFarm.vue": "098f",
	"./Ui/Num.vue": "c847",
	"./Ui/Pie.vue": "43f9",
	"./Ui/Radio.vue": "3159",
	"./Ui/Table.vue": "810f",
	"./Ui/Table/Th.vue": "a022",
	"./Ui/Table/Tr.vue": "c152",
	"./Vote/FormSubmitVote.vue": "56a3",
	"./Vote/NavBarVote.vue": "9055",
	"./Vote/ProposalCard.vue": "7462",
	"./Vote/SearchVote.vue": "7234",
	"./Vote/VoteSelectCategory.vue": "2729",
	"./Vote/VoteSelectTime.vue": "376e",
	"./swap/AssetIcon.vue": "f6a8",
	"./swap/AssetInput.vue": "4a17",
	"./swap/ButtonText.vue": "a115",
	"./swap/Icon.vue": "0fb0",
	"./swap/KurveSwapButton.vue": "2cbc",
	"./swap/Pair.vue": "d4cf",
	"./swap/PairToggle.vue": "7248",
	"./swap/Routing.vue": "1b88",
	"./swap/Settings.vue": "1dae",
	"./swap/SwapButton.vue": "21bc",
	"./swap/Tooltip.vue": "e225",
	"./swap/modals/ModalAccount.vue": "bc83",
	"./swap/modals/ModalAssetSelector.vue": "233a",
	"./swap/modals/ModalBase.vue": "3a87",
	"./swap/modals/ModalConnectorSelector.vue": "1294",
	"./swap/modals/ModalSettings.vue": "f2f6",
	"./swap/modals/ModalTransaction.vue": "f777"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4daf";